<template>
  <i :class="['material-icons', `md-${size}`, `rotate-${rotate}`, { 'rotation-animation': animationOn }]">
    {{ name }}
  </i>
</template>

<script lang="ts">
// https://material.io/icons/
import Vue from "vue";
export default Vue.extend({
  name: "components-icon",
  props: {
    name: { type: String, required: true },
    size: {
      type: Number,
      required: false,
      default: 24,
      validator: (value: number) => [12, 14, 18, 20, 24, 32, 36, 48].indexOf(value) !== -1,
    },
    rotate: {
      type: Number,
      required: false,
      default: 0,
      validator: (value: number) => [0, 90, 180, 270].indexOf(value) !== -1,
    },
    animationOn: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
});
</script>

<style lang="scss" scoped>
.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px; /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;
  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;
  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;
  /* Support for IE. */
  font-feature-settings: "liga";
  &.rotate-0 {
    transform: rotate(0deg);
  }
  &.rotate-90 {
    transform: rotate(90deg);
  }
  &.rotate-180 {
    transform: rotate(180deg);
  }
  &.rotate-270 {
    transform: rotate(270deg);
  }
  &.rotation-animation {
    animation: rotate 2s linear infinite;
  }
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* Rules for sizing the icon. */
.material-icons.md-12 {
  font-size: 12px;
}
.material-icons.md-14 {
  font-size: 14px;
}
.material-icons.md-18 {
  font-size: 18px;
}
.material-icons.md-20 {
  font-size: 20px;
}
.material-icons.md-24 {
  font-size: 24px;
}
.material-icons.md-32 {
  font-size: 32px;
}
.material-icons.md-36 {
  font-size: 36px;
}
.material-icons.md-48 {
  font-size: 48px;
}
</style>
